import React from "react";
import { DatabaseBackupTab } from "../../../../pages-via-dialog/organization-settings/tabs/database-backup/database-backup.tab";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { RolesEnum } from "@/lib/types/roles.types";
import { ShieldOff } from "lucide-react";

export const DatenbankSicherungPage: React.FC = () => {
	const { role = 2 } = useCentralStore((state) => ({
		role: state.role,
	}));

	const isAdmin = role !== null && role <= RolesEnum.ADMIN;

	if (!isAdmin) {
		return (
			<div className="p-6">
				<div className="max-w-6xl">
					<h1 className="text-2xl font-semibold text-gray-900 mb-6">Datenbank Sicherung</h1>
					<div className="border-orange-200 bg-orange-50">
						<ShieldOff className="h-4 w-4 text-orange-600" />
						<div className="text-orange-800">
							Sie haben nicht die erforderlichen Berechtigungen, um auf diese Seite zuzugreifen.
							Nur Administratoren können Datenbank-Backups erstellen.
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<h1 className="text-2xl font-semibold text-gray-900 mb-6">Datenbank Sicherung</h1>
				<div className="bg-white rounded-lg shadow-sm border border-gray-200">
					<DatabaseBackupTab />
				</div>
			</div>
		</div>
	);
};